export const stateName = 'returnShipment';